import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import FetchService from 'service/FetchService';
import {actionMeta} from './meta';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {errorSafeSaga} from 'service/StoreService';

const ty = actionMeta.identifiers;
const api = actionMeta.urlBuilders;
const actions = actionMeta.actionCreators;

function* translationsList(action) {
    let {project_id, string_id, ...otherParams} = action.payload.params;
    const url = api.buildTranslationsListUrl({project_id, string_id});
    const authGet = yield authenticatedRequest(FetchService.get);
    const {response, data} = yield call(authGet, {
        url: url,
        params: otherParams
    });
    const error = response.status !== 200;
    yield put(actions.translationsListResponse({ payload: {data: data}, error: error }));
}

function* watchTranslationsList() {
    yield takeLatest(ty.TRANSLATIONS_LIST_REQUEST, errorSafeSaga(translationsList));
}

function* translationsUpdate(action) {
    let {project_id, string_id, ...otherParams} = action.payload.params;
    const url = api.buildTranslationsUpdateUrl({project_id, string_id});
    const authPut = yield authenticatedRequest(FetchService.put);
    const {response, data} = yield call(authPut, {
        url: url,
        params: {
            ...otherParams
        }
    });
    const error = response.status !== 200;
    yield put(actions.translationsUpdateResponse({ payload: {data: data}, error: error }));
    //yield put(actions.translationsListRequest());
}

function* watchTranslationsUpdate() {
    yield takeLatest(ty.TRANSLATIONS_UPDATE_REQUEST, errorSafeSaga(translationsUpdate));
}


function* translationUploadDefaultMessages(action) {
    let {project_id, string_id,file, ...otherParams} = action.payload.params;
    const url = api.buildTranslationsUploadDefaultMessagesUrl({project_id});
    const authPost = yield authenticatedRequest(FetchService.post);

    const formData  = new FormData();
    formData.append('file', file);

    const {response, data} = yield call(authPost, {
        url: url,
        params: {},
        body: formData,
        json_headers: false
    });
    const error = response.status !== 200;
    yield put(actions.translationsUploadDefaultMessagesResponse({ payload: {data: data}, error: error }));
    yield put(actions.translationsListRequest({
        project_id, string_id
    }));
}

function* watchTranslationUploadDefaultMessages() {
    yield takeLatest(ty.TRANSLATIONS_UPLOAD_DEFAULT_MESSAGES_REQUEST, errorSafeSaga(translationUploadDefaultMessages));
}

function* translationUploadLocaleMessages(action) {
    let {project_id, string_id, file, ...otherParams} = action.payload.params;
    const url = api.buildTranslationsUploadLocaleMessagesUrl({project_id, string_id});
    const authPost = yield authenticatedRequest(FetchService.post);

    const formData  = new FormData();
    formData.append('file', file);

    const {response, data} = yield call(authPost, {
        url: url,
        params: {},
        body: formData,
        json_headers: false
    });
    const error = response.status !== 200;
    yield put(actions.translationsUploadLocaleMessagesResponse({payload: {data: data}, error: error}));
    yield put(actions.translationsListRequest({
        project_id, string_id
    }));
}

function* watchTranslationUploadLocaleMessages() {
    yield takeLatest(ty.TRANSLATIONS_UPLOAD_LOCALE_MESSAGES_REQUEST, errorSafeSaga(translationUploadLocaleMessages));
}


function* saga() {
  yield all([
    fork(watchTranslationsList),
    fork(watchTranslationUploadDefaultMessages),
    fork(watchTranslationUploadLocaleMessages),
    fork(watchTranslationsUpdate),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/translations/saga.js